import "./header.css";
import React from "react";
import HavayarLogoSignImage from "../../assets/images/general/havayar_logo_type.svg";

export default function Header() {
    return (
        <header>
            <nav className="row header-nav">
                <a className="col"  href="https://www.havayar.com/">
                    <img src={HavayarLogoSignImage} alt="havayar logo" className="headerlogoimage" />
                </a>
            </nav>
        </header>
    );
}
